<template>
  <div>
    <ys-data-table
      ref="tableData"
      v-model="refresh"
      :list="searchList"
      :fetch-method="fetchMethod"
      :columns="columns"
      :transform-params="handleTransformParams"
      :dep-option-map="optionsMap"
      page-alias="p"
      page-size-alias="psize"
      use-data-field
      max-height="600"
      @selection-change="handleSelectionChange"
      @on-fetch-success="handleFetchSuccess"
      @on-change="handleParamsChange"
    >
      <template #table-title>
        <el-row type="flex" justify="end">
          <el-button type="primary" size="small" @click="handleMultipleEdit">
            批量修改
          </el-button>
          <el-button type="success" size="small" @click="handleMultipleRecover">
            批量导入恢复正常
          </el-button>
          <el-button type="primary" size="small" @click="handleRecoverNormal">
            恢复正常
          </el-button>
          <el-button
            type="primary"
            size="small"
            @click="handleMultipleApplyDeficit"
          >
            批量申请盘亏
          </el-button>
          <el-button type="primary" size="small" @click="handleCompensateClick">
            申请赔付
          </el-button>
          <el-button type="success" size="small" @click="handleExport">
            导出
          </el-button>
        </el-row>
      </template>
      <template #dbid="{ row }">
        <div @click="openQrCode('dbid=' + row.dbid)">
          {{ row.dbid }}
        </div>
      </template>
      <template #goods_img="{ row }">
        <img
          v-if="row.goods_img[0]"
          :src="row.goods_img[0]"
          style="width: 60px; height: 60px; object-fit: cover"
          alt=""
          @click="handleViewImage(row.goods_img)"
        />
      </template>
      <template #actions="{ row, index }">
        <el-button
          v-if="row.status === constantMap.isException"
          type="primary"
          size="small"
          @click="handleEdit(row, index)"
        >
          编辑
        </el-button>
      </template>
    </ys-data-table>
    <!-- 批量修改 -->
    <el-dialog
      :visible.sync="visibleMultipleEdit"
      :close-on-click-modal="false"
      title="批量修改"
      @close="handleMultipleEditClose"
    >
      <el-form ref="formMultipleEdit" :model="formMultipleEdit">
        <el-form-item label="" prop="excel">
          <ys-upload-combo
            v-model="formMultipleEdit.excel"
            :download-temp="handleDownloadEditTemp"
            btn-upload="选择文件"
            btn-list=""
          ></ys-upload-combo>
        </el-form-item>
        <div>请先下载模版，与模版一样格式</div>
        <div style="color: #fb0825">
          注意：若为第三方理赔，第三方责任部门为必填项
        </div>
      </el-form>
      <template #footer>
        <el-button @click="visibleMultipleEdit = false">取消</el-button>
        <el-button type="primary" @click="handleConfirmMultipleEdit">
          确认
        </el-button>
      </template>
    </el-dialog>
    <!-- 批量申请盘亏 -->
    <el-dialog
      :visible.sync="visibleApplyDeficit"
      :close-on-click-modal="false"
      title="批量申请盘亏"
      @close="handleApplyDeficitClose"
    >
      <el-form ref="formApplyDeficit" :model="formApplyDeficit">
        <el-form-item label="" prop="excel">
          <ys-upload-combo
            v-model="formApplyDeficit.excel"
            :download-temp="handleDownloadDeficitTemp"
            btn-upload="选择文件"
            btn-list=""
          ></ys-upload-combo>
        </el-form-item>
        <div>请先下载模版，与模版一样格式</div>
        <div style="color: #fb0825">
          注意：若为第三方理赔，第三方责任部门为必填项
        </div>
      </el-form>
      <template #footer>
        <el-button @click="visibleApplyDeficit = false">取消</el-button>
        <el-button type="primary" @click="handleConfirmMultipleApplyDeficit">
          确认
        </el-button>
      </template>
    </el-dialog>
    <!-- 批量导入恢复正常 -->
    <el-dialog
      :visible.sync="visibleMultipleRecover"
      :close-on-click-modal="false"
      title="批量导入恢复正常"
      @close="handleMultipleRecoverClose"
    >
      <el-form ref="formMultipleRecover" :model="formMultipleRecover">
        <el-form-item label="" prop="excel">
          <ys-upload-combo
            v-model="formMultipleRecover.excel"
            :download-temp="handleDownloadRecoverTemp"
            btn-upload="选择文件"
            btn-list=""
          ></ys-upload-combo>
        </el-form-item>
        <div>请先下载模版，与模版一样格式，并且确保每行数据正确，不能为空</div>
      </el-form>
      <template #footer>
        <el-button @click="visibleMultipleRecover = false">取消</el-button>
        <el-button type="primary" @click="handleConfirmMultipleRecover">
          确认
        </el-button>
      </template>
    </el-dialog>
    <!-- 编辑 -->
    <el-dialog
      :visible.sync="visibleEdit"
      :close-on-click-modal="false"
      width="600px"
      title="编辑"
      @close="handleEditClose"
    >
      <el-form ref="formEdit" :model="formEdit" label-width="80px">
        <el-form-item
          label="异常原因"
          prop="cause_id"
          :rules="rules.ruleChange"
        >
          <el-select v-model="formEdit.cause_id">
            <el-option
              v-for="item in oldOptionsMap.reasonList"
              :key="item.rdid"
              :label="item.rdname"
              :value="`${item.rdid}`"
            ></el-option>
            <el-option
              v-for="item in optionsMap.reasonList"
              :key="item.rdid"
              :label="item.rdname"
              :value="`${item.rdid}`"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="责任部门" prop="rd_id">
          <el-cascader
            v-model="formEdit.rd_id"
            :options="optionsMap.departmentList"
            :props="{ checkStrictly: true }"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="责任人" prop="r_personnel">
          <ys-input
            v-model="formEdit.r_personnel"
            :maxlength="constantMap.maxName"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="visibleEdit = false">取消</el-button>
        <el-button type="primary" @click="handleConfirmEdit"> 确认 </el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from "dayjs";
import Global_ from "../../components/Global.vue";
import { applyCompensate } from "@/controller/stockInRecord.js";
import * as preStockManageApi from "@/controller/preStockManage3155.js";
import { openDownloadWindow } from "@/utils/export.js";
import * as modiCommonConfigApi from "@/controller/modiCommonConfig3652.js";
import * as goodsExceptionApi from "@/controller/goodsException3646.js";
import rules from "@/const/rules.js";

const constantMap = Object.freeze({
  department: "zerenbumen",
  reason: "yichangyuanyin",
  isUse: "1",
  isAll: "2",
  maxName: 50,
  isException: "1",
  isNone: "0",
});
const changeCascaderData = (data) => {
  return data?.map((item) => {
    const { rdname, rdid, children, ...rest } = item;
    return changeCascaderData(children)?.length
      ? {
          ...rest,
          label: item.rdname,
          value: item.rdid,
          children: changeCascaderData(children),
        }
      : {
          ...rest,
          label: item.rdname,
          value: item.rdid,
        };
  });
};
/**
 * 找到选择的节点
 * @param list
 * @param ids
 * @returns {null}
 */
const findSelectedChild = (list, ids) => {
  const idList = ids?.slice();
  let id = idList?.shift();
  let arr = list?.slice();
  let hitItem = null;
  while (arr && id) {
    // eslint-disable-next-line no-loop-func
    hitItem = arr.find((item) => item.value === id);
    arr = hitItem?.children;
    id = idList.shift();
  }
  return hitItem;
};
/**
 * 找到节点所有的子节点id
 * @param data
 * @param result
 * @returns {*[]|*}
 */
const getAllChildrenId = (data, result = []) => {
  if (data?.children?.length) {
    data.children.forEach((item) => {
      result.push(item.value);
      getAllChildrenId(item.children, result);
    });
  }
  return result;
};
export default {
  name: "StockDetailErrorDetail",
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.handleGetOptions();
      // eslint-disable-next-line no-param-reassign
      vm.refresh = true;
    });
  },
  data() {
    return {
      constantMap,
      rules,
      refresh: false,
      searchList: [
        {
          tag: "input",
          label: "商品货号",
          field: "goods_no",
          props: {
            pattern: "positiveInt",
          },
        },
        {
          tag: "input",
          label: "打标ID",
          field: "dbid",
        },
        {
          tag: "input",
          label: "sku",
          field: "sku",
        },
        {
          tag: "input",
          label: "商家",
          field: "supply_name",
        },
        {
          tag: "input",
          label: "市场",
          field: "market_name",
        },
        {
          tag: "input",
          label: "品牌",
          field: "brand_name",
        },
        {
          tag: "select",
          label: "异常来源",
          field: "exception_source",
          optionsField: "exception_source_option",
        },
        {
          tag: "select",
          label: "入库来源",
          field: "stock_in_source",
          optionsField: "stock_in_stock_source_option",
        },
        {
          tag: "select",
          label: "仓区",
          field: "origin",
          optionsField: "stock_in_record_origin_option",
        },
        {
          tag: "select",
          label: "异常原因",
          field: "cause_id",
          optionsField: "allReasonList",
          labelKey: "rdname",
          valueKey: "rdid",
        },
        {
          tag: "cascader",
          label: "责任部门",
          field: "rd_id",
          defaultValue: [],
          optionsField: "allDepartmentList",
          props: {
            props: {
              multiple: true,
              checkStrictly: true,
            },
            "collapse-tags": true,
          },
        },
        {
          tag: "input",
          label: "责任人",
          field: "r_personnel",
        },
        {
          tag: "date",
          label: "入库时间",
          field: "stock_in_time",
          props: {
            type: "datetimerange",
            placeholder: "请选择",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            defaultTime: ["06:00:00", "06:00:00"],
          },
          transform: (list) => {
            return {
              stock_in_time: list
                ? list.map((date) => dayjs(date).format("YYYY-MM-DD HH:mm:ss"))
                : "",
            };
          },
        },
        {
          tag: "date",
          label: "标记异常时间",
          field: "exception_time",
          props: {
            type: "datetimerange",
            placeholder: "请选择",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            defaultTime: ["06:00:00", "06:00:00"],
          },
          transform: (list) => {
            return {
              exception_time: list
                ? list.map((date) => dayjs(date).format("YYYY-MM-DD HH:mm:ss"))
                : "",
            };
          },
        },
      ],
      fetchMethod: preStockManageApi.exceptionList,
      columns: [
        {
          type: "selection",
          width: "55",
          fixed: "left",
        },
        {
          label: "打标id",
          slot: "dbid",
        },
        {
          label: "商品图片",
          slot: "goods_img",
        },
        {
          label: "商品名称",
          prop: "goods_name",
          "show-overflow-tooltip": true,
        },
        {
          label: "商品货号/颜色/尺码",
          prop: "goods_no_co_si_val",
          "show-overflow-tooltip": true,
        },
        {
          label: "sku",
          prop: "sku",
          "show-overflow-tooltip": true,
        },
        {
          label: "商品分类",
          prop: "cat_name",
          "show-overflow-tooltip": true,
        },
        {
          label: "商家/市场/品牌",
          prop: "supply_market_brand",
          "show-overflow-tooltip": true,
        },
        {
          label: "打标方式",
          prop: "da_biao_record_type",
        },
        {
          label: "入库来源",
          prop: "stock_in_record_stock_source",
        },
        {
          label: "异常来源",
          prop: "exception_dbid_source",
        },
        {
          label: "仓区",
          prop: "stock_in_record_origin",
        },
        {
          label: "商品异常状态",
          prop: "exception_status_msg",
        },
        {
          label: "标记人",
          prop: "exception_admin_name",
        },
        {
          label: "标记异常时间",
          prop: "exception_time",
        },
        {
          label: "异常原因",
          prop: "cause",
        },
        {
          label: "责任部门",
          prop: "responsibility_department",
        },
        {
          label: "责任人",
          prop: "responsibility_personnel",
        },
        {
          label: "修改人",
          prop: "edit_user_name",
        },
        {
          label: "修改时间",
          prop: "edit_datetime",
        },
        {
          label: "操作",
          slot: "actions",
          fixed: "right",
        },
      ],
      optionsMap: {
        reasonList: [],
        departmentList: [],
      },
      oldOptionsMap: {
        reasonList: [],
      },
      searchParams: {},
      multipleSelection: [],
      visibleMultipleEdit: false,
      formMultipleEdit: {
        excel: null,
      },
      visibleApplyDeficit: false,
      formApplyDeficit: {
        excel: null,
      },
      visibleMultipleRecover: false,
      formMultipleRecover: {
        excel: null,
      },
      visibleEdit: false,
      formEdit: {
        cause_id: "",
        rd_id: "",
        r_personnel: "",
      },
      currentRow: {},
      currentIndex: -1,
    };
  },
  methods: {
    handleGetOptions() {
      modiCommonConfigApi
        .operationReasonOption({
          key: constantMap.department,
          query_scope: constantMap.isAll,
        })
        .then((res) => {
          this.optionsMap.allDepartmentList = changeCascaderData(res);
        })
        .catch(this.$noop);
      modiCommonConfigApi
        .operationReasonOption({
          key: constantMap.reason,
          query_scope: constantMap.isAll,
        })
        .then((res) => {
          this.optionsMap.allReasonList = res;
        })
        .catch(this.$noop);
      modiCommonConfigApi
        .operationReasonOption({
          key: constantMap.department,
          query_scope: constantMap.isUse,
        })
        .then((res) => {
          this.optionsMap.departmentList = changeCascaderData(res);
        })
        .catch(this.$noop);
      modiCommonConfigApi
        .operationReasonOption({
          key: constantMap.reason,
          query_scope: constantMap.isUse,
        })
        .then((res) => {
          this.optionsMap.reasonList = res;
        })
        .catch(this.$noop);
    },
    handleExport() {
      preStockManageApi
        .exceptionList({ ...this.searchParams, is_excel: 1 })
        .then(openDownloadWindow)
        .catch(this.$noop);
    },
    openQrCode(text) {
      if (Global_.environment === 0) {
        this.$alert(
          `<img src="https://tool.oschina.net/action/qrcode/generate?data=${text}" />`,
          text,
          {
            dangerouslyUseHTMLString: true,
            showConfirmButton: false,
            closeOnClickModal: true,
            center: true,
          }
        );
      }
    },
    handleCompensateClick() {
      if (this.multipleSelection.length === 0) {
        this.$message.info("请先勾选商品");
      } else {
        const dbids = this.multipleSelection.map((item) => {
          return item.dbid;
        });
        this.$confirm(
          `已选${dbids.length}件商品，赔付后将不能恢复正常，确定申请赔付？`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            closeOnClickModal: false,
          }
        ).then(() => {
          const params = {
            dbids,
          };
          applyCompensate(params)
            .then(() => {
              this.$message.success("申请成功");
              this.refresh = true;
            })
            .catch(this.$noop);
        });
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleFetchSuccess(res) {
      const {
        list,
        exception_source_option: exceptionSourceOption,
        ...rest
      } = res;
      this.optionsMap = {
        ...this.optionsMap,
        ...rest,
        exception_source_option: [
          { label: "全部", value: "0" },
          ...exceptionSourceOption,
        ],
      };
    },
    handleParamsChange(params) {
      this.searchParams = params;
    },
    handleViewImage(images) {
      this.$viewerApi({
        images,
      });
    },
    handleTransformParams(params) {
      const {
        stock_in_source: stockInSource,
        rd_id: rdIdList,
        ...rest
      } = params;
      const rdIds =
        rdIdList
          ?.map((ids) => {
            const hitItem = findSelectedChild(
              this.optionsMap.allDepartmentList,
              ids
            );
            return getAllChildrenId(hitItem, [hitItem.value]);
          })
          .flat() || [];
      return stockInSource
        ? { stock_in_source: stockInSource, rd_id: rdIds, ...rest }
        : { rd_id: rdIds, ...rest };
    },
    handleEdit(row, index) {
      const { cause_id: causeId, responsibility_personnel: rPersonnel } = row;
      // 将已删除的原因回显
      const isUseReason = this.optionsMap.reasonList.some(
        (item) => String(item.rdid) === causeId
      );
      if (!isUseReason) {
        const oldReason = this.optionsMap.allReasonList.find(
          (item) => String(item.rdid) === causeId
        );
        this.oldOptionsMap.reasonList = oldReason ? [oldReason] : [];
      } else {
        this.oldOptionsMap.reasonList = [];
      }
      this.currentRow = row;
      this.currentIndex = index;
      this.formEdit = {
        cause_id: causeId === constantMap.isNone ? "" : causeId,
        rd_id: "",
        r_personnel: rPersonnel,
      };
      this.visibleEdit = true;
    },
    handleEditClose() {
      this.$refs.formEdit.resetFields();
      this.formEdit = this.$options.data().formEdit;
    },
    handleConfirmEdit() {
      this.$refs.formEdit.validate((valid) => {
        if (valid) {
          const { rd_id: rdid, ...rest } = this.formEdit;
          goodsExceptionApi
            .causeEdit({
              rd_id: rdid[rdid.length - 1] || "0",
              ...rest,
              id: this.currentRow.id,
            })
            .then(() => {
              this.$message.success("操作成功！");
              this.visibleEdit = false;
              this.$refs.tableData.update(this.currentIndex, {
                dbid: this.currentRow.dbid,
              });
            })
            .catch(this.$noop);
        }
      });
    },
    handleMultipleEdit() {
      this.visibleMultipleEdit = true;
    },
    handleConfirmMultipleEdit() {
      if (!this.formMultipleEdit.excel) {
        this.$message.info("请选择文件");
        return;
      }
      this.$refs.formMultipleEdit.validate((valid) => {
        if (valid) {
          goodsExceptionApi
            .causeBatchEdit(this.formMultipleEdit)
            .then((res) => {
              if (res.error_count) {
                this.$message.success(
                  `${res.succeed_count}条处理成功，${res.error_count}条处理失败`
                );
                setTimeout(() => {
                  openDownloadWindow(res);
                }, 300);
              } else {
                this.$message.success(`${res.succeed_count}条处理成功`);
              }
              this.visibleMultipleEdit = false;
              this.refresh = true;
            })
            .catch(this.$noop);
        }
      });
    },
    handleMultipleEditClose() {
      this.$refs.formMultipleEdit.resetFields();
      this.formMultipleEdit = this.$options.data().formMultipleEdit;
    },
    handleDownloadEditTemp() {
      goodsExceptionApi
        .exportCauseBatchDemo()
        .then(openDownloadWindow)
        .catch(this.$noop);
    },
    handleMultipleRecover() {
      this.visibleMultipleRecover = true;
    },
    handleConfirmMultipleRecover() {
      if (!this.formMultipleRecover.excel) {
        this.$message.info("请选择文件");
        return;
      }
      this.$refs.formMultipleRecover.validate((valid) => {
        if (valid) {
          goodsExceptionApi
            .getRightBatchEdit(this.formMultipleRecover)
            .then((res) => {
              if (res.error_count) {
                this.$message.success(
                  `${res.succeed_count}条处理成功，${res.error_count}条处理失败`
                );
                setTimeout(() => {
                  openDownloadWindow(res);
                }, 300);
              } else {
                this.$message.success(`${res.succeed_count}条处理成功`);
              }
              this.visibleMultipleRecover = false;
              this.refresh = true;
            })
            .catch(this.$noop);
        }
      });
    },
    handleMultipleRecoverClose() {
      this.$refs.formMultipleRecover.resetFields();
      this.formMultipleRecover = this.$options.data().formMultipleRecover;
    },
    handleDownloadRecoverTemp() {
      goodsExceptionApi
        .exportGetRightBatchDemo()
        .then(openDownloadWindow)
        .catch(this.$noop);
    },
    handleRecoverNormal() {
      if (!this.multipleSelection.length) {
        this.$message.info("请先勾选商品");
        return;
      }
      goodsExceptionApi
        .getRight({
          dbid: this.multipleSelection.map((item) => item.dbid),
        })
        .then(() => {
          this.$message.success("操作成功！");
          this.refresh = true;
        })
        .catch(this.$noop);
    },
    handleMultipleApplyDeficit() {
      this.visibleApplyDeficit = true;
    },
    handleConfirmMultipleApplyDeficit() {
      if (!this.formApplyDeficit.excel) {
        this.$message.info("请选择文件");
        return;
      }
      this.$refs.formApplyDeficit.validate((valid) => {
        if (valid) {
          goodsExceptionApi
            .batchInventoryLosses(this.formApplyDeficit)
            .then(() => {
              this.$message.success("操作成功");
              this.visibleApplyDeficit = false;
              this.refresh = true;
            })
            .catch((e) => {
              if (e.code === 400) {
                openDownloadWindow(e.data);
              }
            });
        }
      });
    },
    handleApplyDeficitClose() {
      this.$refs.formApplyDeficit.resetFields();
      this.formApplyDeficit = this.$options.data().formApplyDeficit;
    },
    handleDownloadDeficitTemp() {
      goodsExceptionApi
        .exportInventoryLossesDemo()
        .then(openDownloadWindow)
        .catch(this.$noop);
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/wavepicking/StockDetailErrorDetail.vue